import { useState } from 'react'

import { Box } from '@chakra-ui/react'

import { useAddInterviewParticipant } from '@/react-query/interview/interview-participants'

import { AddInterviewerButton } from './components/AddInterviewerButton'
import { SearchInput } from './components/SearchInput'
import { SearchResultsDropdown } from './components/SearchResultsDropdown'
import { useDropdownHandler } from './hooks/useDropdownHandler'
import { useFilteredTeamMembers } from './hooks/useFilteredTeamMembers'

export const AddInterviewerMenu = () => {
  const [searchQuery, setSearchQuery] = useState('')
  const [showResults, setShowResults] = useState(false)
  const [isExpanded, setIsExpanded] = useState(false)

  const addParticipant = useAddInterviewParticipant()
  const { dropdownRef, inputRef } = useDropdownHandler(
    isExpanded,
    searchQuery,
    setShowResults,
    setIsExpanded,
    setSearchQuery,
  )
  const { filteredMembers, availableMembers, isLoadingMembers } =
    useFilteredTeamMembers(searchQuery)

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value
    setSearchQuery(value)
    setShowResults(true)
  }

  const handleMemberSelect = (memberId: string) => {
    addParticipant.mutate({
      userId: memberId,
    })

    setShowResults(false)
    setSearchQuery('')
    setIsExpanded(false)
  }

  if (!isExpanded) {
    return (
      <AddInterviewerButton
        onClick={() => setIsExpanded(true)}
        isDisabled={false}
        isLoading={addParticipant.isPending}
      />
    )
  }

  return (
    <Box position="relative" mt={5} overflow="visible">
      <SearchInput
        inputRef={inputRef}
        searchQuery={searchQuery}
        onChange={handleSearchChange}
        onFocus={() => setShowResults(true)}
        showResults={showResults}
        isLoading={addParticipant.isPending}
      />

      <SearchResultsDropdown
        showResults={showResults}
        dropdownRef={dropdownRef}
        isLoadingMembers={isLoadingMembers}
        filteredMembers={filteredMembers}
        availableMembers={availableMembers}
        searchQuery={searchQuery}
        onMemberSelect={handleMemberSelect}
      />
    </Box>
  )
}
